import { CreateCustomField } from 'components/CustomFieldCreateModal/views/CreateCustomFieldView/CreateCustomField';
import { QuerySwitch } from 'components/QuerySwitch';
import { FetchCustomFieldsDataContext } from 'pages/SettingsPage/CustomFieldsSettingsPage/contexts/FetchCustomFields.data.context';
import { FC } from 'react';

export const CreateCustomFieldView: FC = () => {
  return <QuerySwitch context={FetchCustomFieldsDataContext} component={CreateCustomField} />;
};
